import React, { useState } from "react";
import { Card, Table, Container } from "react-bootstrap";
import { Link } from "react-router-dom";
import PageTitle from "@/common/PageTitle/PageTitle";
import PaginationRow from "@/components/PaginationRow/PaginationRow";
import styles from './LocationZonesList.module.scss';

interface LocationZonesListProps {
  companyNumber: string;
  locationId: string;
}

const LocationZonesList: React.FC<LocationZonesListProps> = ({ companyNumber, locationId }) => {
  const [page, setPage] = useState(1);

  // Test data
  const testZones = [
    {
      id: "1",
      zoneNumber: "Zone 01",
      description: "Main Dining Area",
      device: "KrossKast Player",
      subscription: "Premium",
      messaging: "Enabled",
      user: "johndoecompany_01_z01",
      role: "Admin"
    },
    {
      id: "2",
      zoneNumber: "Zone 02",
      description: "Bar Area",
      device: "KrossKast Player",
      subscription: "Standard",
      messaging: "Enabled",
      user: "johndoecompany_01_z02",
      role: "Manager"
    },
    {
      id: "3",
      zoneNumber: "Zone 03",
      description: "Outdoor Seating",
      device: "KrossKast Player",
      subscription: "Premium",
      messaging: "Disabled",
      user: "johndoecompany_01_z03",
      role: "User"
    }
  ];

  const zones = testZones;
  const totalPages = 1;

  const handleOnClickNext = () => {
    if (page < totalPages) {
      setPage(page + 1);
    }
  };

  const handleOnClickPrev = () => {
    if (page > 1) {
      setPage(page - 1);
    }
  };

  const handleDelete = (zoneId: string) => {
    // TODO: Implement delete functionality
    console.log('Delete zone:', zoneId);
  };

  return (
    <Container fluid>
      <Card style={{ borderRadius: 12 }}>
        <Card.Body>
          <Card.Title style={{ display: 'flex', justifyContent: 'space-between' }}>
            <PageTitle title="Location Zones" />
            <Link to={`/client-locations/${companyNumber}/locations`} className="btn btn-outline-primary">
              Back to Locations
            </Link>
          </Card.Title>
        <Table hover responsive className="legacy-row-height-table" style={{ tableLayout: 'fixed' }}>
          <thead>
            <tr>
              <th style={{ minWidth: 100, maxWidth: 140, width: 120 }}>Zone Number</th>
              <th>Zone Description</th>
              <th className={styles['device-col']} style={{ minWidth: '80px', maxWidth: '110px', width: '90px', whiteSpace: 'nowrap' }}>Device</th>
              <th style={{ minWidth: 100, maxWidth: 140, width: 120 }}>Subscription</th>
              <th style={{ minWidth: 80, maxWidth: 120, width: 100, whiteSpace: 'nowrap' }}>Messaging</th>
              <th style={{ minWidth: 180, maxWidth: 220, width: 200, whiteSpace: 'nowrap' }}>User</th>
              <th style={{ minWidth: 80, maxWidth: 120, width: 100, whiteSpace: 'nowrap' }}>Role</th>
              <th style={{ minWidth: 180, maxWidth: 220, width: 200, whiteSpace: 'nowrap' }}>Actions</th>
            </tr>
          </thead>
          <tbody>
            {zones.map((zone) => (
              <tr key={zone.id}>
                <td style={{ minWidth: 100, maxWidth: 140, width: 120 }}>{zone.zoneNumber}</td>
                <td>{zone.description}</td>
                <td className={styles['device-col']} style={{ minWidth: '80px', maxWidth: '110px', width: '90px', whiteSpace: 'nowrap' }}>{zone.device}</td>
                <td style={{ minWidth: 100, maxWidth: 140, width: 120 }}>{zone.subscription}</td>
                <td style={{ minWidth: 80, maxWidth: 120, width: 100, whiteSpace: 'nowrap' }}>{zone.messaging}</td>
                <td style={{ minWidth: 180, maxWidth: 220, width: 200, whiteSpace: 'nowrap' }}>{zone.user}</td>
                <td style={{ minWidth: 80, maxWidth: 120, width: 100, whiteSpace: 'nowrap' }}>{zone.role}</td>
                <td style={{ minWidth: 180, maxWidth: 220, width: 200, whiteSpace: 'nowrap' }}>
                  <span style={{ cursor: 'pointer', color: '#1677ff', marginRight: 12 }} onClick={() => {/* TODO: View handler */}}>View</span>
                  <span style={{ cursor: 'pointer', color: '#1677ff', marginRight: 12 }} onClick={() => {/* TODO: Edit handler */}}>Edit</span>
                  <span style={{ cursor: 'pointer', color: '#e21e26' }} onClick={() => handleDelete(zone.id)}>Delete</span>
                </td>
              </tr>
            ))}
            {zones.length === 0 && (
              <tr>
                <td colSpan={8} className="text-center">
                  No zones found
                </td>
              </tr>
            )}
          </tbody>
        </Table>
        {totalPages > 1 && (
          <PaginationRow
            page={page}
            onPageChange={(p) => setPage(p)}
            totalPages={typeof totalPages === "number" ? totalPages : undefined}
            onClickPrevious={handleOnClickPrev}
            handleOnClickNext={handleOnClickNext}
            disableLeft={page === 1}
            disableNext={page === totalPages}
          />
        )}
        </Card.Body>
      </Card>
    </Container>
  );
};

export default LocationZonesList; 